import styled from "styled-components";

export const FormWrap = styled.form`
  gap: 25px;
  display: flex;
  flex-direction: column;
  a {
    width: fit-content;
  }
`;
